import React, { useState } from 'react';
import Image from 'next/image';
import { IC_LEGENDS, IC_ICONS, IC_INFO_BLUE, IC_CLOSE_GREY } from '../../Assets/images';
import { AsterIconStyled } from './AsterIconsStyled';
import CustomModal from '../Modal/Modal';
import PropTypes from 'prop-types';
import { ASTER_ICON_TITLE } from '../../Utility/constants';

const AsterIcons = ({ legendsImage, lengendsText, customModal, isFromMyDoctors, infoIcon, show, onShowChange }) => {
  const [clickedInformation, setClickedInformation] = useState(false);
  const getAsterIcon = () => {
    if (!customModal) {
      if (lengendsText === 'legends') {
        return <Image src={legendsImage} alt="legends" width={115} height={28} />;
      } else if (lengendsText !== 'legends') {
        return <Image src={legendsImage} alt="legends" width={110} height={28} />;
      }
    } else {
      if (lengendsText === 'legends') {
        return <Image src={legendsImage} alt="legends" width={141} height={32} />;
      } else if (lengendsText !== 'legends') {
        return <Image src={legendsImage} alt="legends" width={135} height={27} />;
      }
    }
  };
  return (
    <AsterIconStyled>
      <>
        <div className={!customModal ? (isFromMyDoctors ? 'asterIconFacility' : 'asterIconWrapper') : null}>
          {getAsterIcon()}
          {infoIcon && (
            <Image
              src={IC_INFO_BLUE}
              alt="info"
              width={15}
              height={15}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setClickedInformation(true);
                onShowChange(!show)
              }}
            />
          )}
        </div>
        {clickedInformation && (
          <CustomModal customClass="doctorCardInfo" bodyTextCenter noFooter size="md">
            <div
              className="modal_wrapper"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <div className="modalWrapperTop">
                <div className="modalHeaderWrapper">
                  <div className="modalHeader">{ASTER_ICON_TITLE}</div>
                  <div
                    className="closeBtn"
                    onClick={(e) => {
                      setClickedInformation(false);
                      onShowChange(!show)
                    }}
                  >
                    {' '}
                    <Image src={IC_CLOSE_GREY} alt="close" width={24} height={24} />
                  </div>
                </div>
                <div className="modalDescription">
                  We've honored our valuable doctors who have been with us for many years.
                </div>
              </div>
              <div className="modalWrapperBelow">
                <div className="doctorIconWrapper">
                  <div className="doctorIcon">
                    <AsterIcons legendsImage={IC_LEGENDS} lengendsText="legends" customModal />
                  </div>

                  <div className="doctorIconDescription">
                    Dedicated doctor who has served Aster for more than <span className="blueText">20 years.</span>
                  </div>
                </div>
                <div className="doctorIconWrapper">
                  <div className="doctorIcon">
                    <AsterIcons legendsImage={IC_ICONS} lengendsText="icons" customModal />
                  </div>
                  <div className="doctorIconDescription">
                    Dedicated doctor who has served Aster for more than <span className="blueText">15 years.</span>
                  </div>
                </div>
              </div>
            </div>
          </CustomModal>
        )}
      </>
    </AsterIconStyled>
  );
};

AsterIcons.propTypes = {
  legendsImage: PropTypes.object,
  lengendsText: PropTypes.string,
  customModal: PropTypes.bool,
  isFromMyDoctors: PropTypes.bool,
  infoIcon: PropTypes.bool,
  show: PropTypes.bool,
  onShowChange: PropTypes.func
};
AsterIcons.defaultProps = {
  legendsImage: {},
  lengendsText: '',
  customModal: false,
  isFromMyDoctors: false,
  infoIcon: false,
  show: true,
  onShowChange: () => {}, 
};

export default AsterIcons;
